import { render, staticRenderFns } from "./test-card.vue?vue&type=template&id=422786e0&scoped=true"
import script from "./test-card.vue?vue&type=script&lang=js"
export * from "./test-card.vue?vue&type=script&lang=js"
import style0 from "./test-card.vue?vue&type=style&index=0&id=422786e0&prod&lang=scss&scoped=true"
import style1 from "./test-card.vue?vue&type=style&index=1&id=422786e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422786e0",
  null
  
)

export default component.exports